<template>
  <vs-popup class="customer-account-limit-request-create-popup"
            id="popup"
            title="CREATE ACCOUNT LIMIT REQUEST"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="change_to" name="change_to" rules="required|integer|min_number:10000000 " v-slot="{ errors }">
                <small class="label">Change To</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-success">
                      <span>{{__accountCurrency()}}</span>
                    </div>
                  </template>
                  <vs-input v-model="createForm.change_to"  name="change_to" class="w-full" label=""/>
                </vx-input-group>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="reason_for_change" name="reason_for_change" rules="required" v-slot="{ errors }">
                <small class="label">Reason for Change</small>
                <vs-textarea class="mb-0" v-model="createForm.reason_for_change" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      createForm: {},
    }
  }

export default {
  name: 'CustomerAccountLimitRequestCreatePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
      } catch (error) {

      }
    },
    async onClickCreateSite () {
      const vue = this;
      this.$vs.loading()
       try {
        let payload = {}
        Object.assign(payload, this.createForm)
         // format decimal places
         payload.change_to = (Number(payload.change_to)).toFixed(2)
         await CustomerRepository.createAccountLimitRequest(payload)
         this.showSuccessMessage('Account Limit Request created successfully')
         this.open = false;
         await vue.$parent.refreshData()
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    }
  },
  async mounted () {

  },
  components: {

  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-account-limit-request-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
